const toText = (message: unknown): string => {
  if (Array.isArray(message))
    return message.filter(Boolean).map(String).join(', ');
  return typeof message === 'string' ? message : '';
};

/**
 * Extract the message the backend sent, wherever it put it: an axios error
 * (.response.data), or an in-band `{ success: false }` body — a rejected thunk
 * payload is already the body, and the RTI submits answer `{ success, data }`
 * with the reason on `data.message`, on `data.response.message` when it came
 * straight back from HMRC, or on `error`.
 * Returns '' when the backend said nothing, so callers can fall back.
 */
export const getBackendMessage = (source: any): string =>
  toText(
    source?.response?.data?.message ??
      source?.data?.response?.message ??
      source?.data?.message ??
      source?.message ??
      source?.error?.message ??
      source?.error,
  );

/**
 * Extract user-friendly error message from API errors.
 * Handles NestJS responses where message can be string or string[].
 */
export const getErrorMessage = (error: any): string =>
  getBackendMessage(error) || 'An unexpected error occurred';
